'use strict';

const Vue = require('vue/dist/vue.common.js');
const App = require('./App');

module.exports = function() {

	return {
		init: init
	};

	function init () {
		launchApp();
	}

	function launchApp () {
		if (!document.querySelector('.notify-tool')) {
			return;
		}

		new Vue(App);
	}

};
